import { createSlice } from "@reduxjs/toolkit";
import addInvoiceApi from "@custom/rtk-apis/billing/invoice/addInvoice";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const addInvoiceSlice = createSlice({
  name: "addInvoiceSlice",
  initialState,
  reducers: {
    closeModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addInvoiceApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addInvoiceApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(addInvoiceApi.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default addInvoiceSlice.reducer;
export const { closeModal } = addInvoiceSlice.actions;
